/* Load the comments provider only when its below-fold container approaches view. */
(function () {
    const comments = document.querySelector('[data-comments-script]');

    if (!comments) {
        return;
    }

    function loadComments() {
        if (comments.dataset.commentsLoaded === 'true') {
            return;
        }

        const script = document.createElement('script');

        comments.dataset.commentsLoaded = 'true';
        script.src = comments.dataset.commentsScript;
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
    }

    if (!('IntersectionObserver' in window)) {
        window.addEventListener('load', loadComments, {once: true});
        return;
    }

    const observer = new IntersectionObserver(function (entries) {
        if (entries.some((entry) => entry.isIntersecting)) {
            observer.disconnect();
            loadComments();
        }
    }, {rootMargin: '600px 0px'});

    observer.observe(comments);
})();
